export default __webpack_public_path__ + "media/images/images_v2/iui/listArrow-01e23212a1f360066abaf5cdf4e7f085.png";